import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';

export default class BuySmsCredit extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            smsPrice: 0,
            price: 1000000
        }
    }
    componentDidMount() {
        var p1 = this.httpPost("api/v1/common/getsettings", {})
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                }
                else {
                    this.state.smsPrice = data.smsPrice;
                }
            });
        Promise.all([p1]).then(r => {
            this.setState({
                loading: false
            })
        })
    }
    save() {
        var orderItems = [{
            companyId: this.state.data.global.company.id,
            total: this.state.price,
            count: this.getCredit(),
            discount: 0,
            discountDescription: ''
        }]
        this.httpPost("api/v1/onlinerecord/create", {
            type: 14,
            orderItems: orderItems,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    var form = document.createElement('form');
                    form.setAttribute('method', 'POST');
                    form.setAttribute('action', 'https://bpm.shaparak.ir/pgwchannel/startpay.mellat');
                    var hiddenField = document.createElement('input');
                    hiddenField.setAttribute('name', 'RefId');
                    hiddenField.setAttribute('value', data.refId);
                    form.appendChild(hiddenField);
                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getCredit() {
        return Math.round(this.state.price / this.state.smsPrice);
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="nk-block">
                            <div className="row g-gs">
                                <div className="col-md-3 col-xxl-3">
                                </div>
                                <div className="col-md-6 col-xxl-3">
                                    <div className="card card-bordered pricing">
                                        <div className="pricing-head">
                                            <div className="pricing-title">
                                                <h4 className="card-title title">خرید یا تمدید ماژولهای سامانه</h4>
                                            </div>
                                        </div>
                                        <div className="pricing-body">
                                            <p>مبلغ مورد نظر جهت شارژ را وارد نمایید</p>
                                            <div className="form-group">
                                                <input placeholder="مبلغ" defaultValue={this.state.price} onChange={e => this.setState({ price: e.target.value })} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                            </div>
                                            <hr />
                                            <ul className="pricing-features">
                                                <li><span className="w-50">تعداد اعتبار</span> <span className="ms-auto">{this.getCredit()} اعتبار</span></li>
                                            </ul>
                                            <div className="pricing-action">
                                                <button className="btn btn-primary" onClick={e => this.save()}>تایید و پرداخت</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}